import { render, staticRenderFns } from "./OnSignC5.vue?vue&type=template&id=f7fdf922&"
import script from "./OnSignC5.vue?vue&type=script&lang=js&"
export * from "./OnSignC5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports